var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoglanish(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4867 15.7194L16.5491 14.0319C16.3809 13.9602 16.194 13.9451 16.0164 13.9889C15.8389 14.0326 15.6804 14.1329 15.5647 14.2745L13.8209 16.405C11.0842 15.1147 8.88182 12.9123 7.59149 10.1756L9.72199 8.43177C9.86391 8.31634 9.96436 8.15782 10.0081 7.9802C10.0519 7.80258 10.0366 7.61553 9.96458 7.44738L8.27705 3.50981C8.19798 3.32854 8.05815 3.18054 7.88166 3.09133C7.70516 3.00213 7.50307 2.9773 7.31023 3.02113L3.65392 3.86489C3.468 3.90782 3.30212 4.01251 3.18336 4.16186C3.06459 4.3112 2.99996 4.4964 3 4.68721C3 13.7049 10.3091 21 19.3128 21C19.5037 21.0001 19.6889 20.9355 19.8384 20.8168C19.9878 20.698 20.0925 20.5321 20.1355 20.3461L20.9792 16.6898C21.0228 16.496 20.9974 16.2931 20.9075 16.116C20.8176 15.9389 20.6688 15.7987 20.4867 15.7194Z",
    fill: "url(#paint0_linear_615_1161)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_615_1161",
    x1: 3,
    y1: 21,
    x2: 22.2926,
    y2: 19.4875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0486F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53C6FD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoglanish);
export default __webpack_public_path__ + "static/media/boglanish.8b54260434e2c21aca062f75fb1b53c9.svg";
export { ForwardRef as ReactComponent };